import { render, staticRenderFns } from "./InspectRobot.vue?vue&type=template&id=a97302b8&scoped=true&lang=pug&"
import script from "./InspectRobot.vue?vue&type=script&lang=js&"
export * from "./InspectRobot.vue?vue&type=script&lang=js&"
import style0 from "./InspectRobot.vue?vue&type=style&index=0&id=a97302b8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97302b8",
  null
  
)

export default component.exports